/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { AcceptAodRunRunActionsMutationRequest, AcceptAodRunRunActionsMutationResponse, AcceptAodRunRunActionsPathParams, AcceptAodRunRunActions400, AcceptAodRunRunActions404 } from "../models/AcceptAodRunRunActions";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { acceptAodRunRunActions } from "../axios/acceptAodRunRunActions";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const acceptAodRunRunActionsMutationKey = () => ["audit-reports-api", { url: '/aod-runs/:id/accept' }] as const

export type AcceptAodRunRunActionsMutationKey = ReturnType<typeof acceptAodRunRunActionsMutationKey>

export function acceptAodRunRunActionsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AcceptAodRunRunActionsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = acceptAodRunRunActionsMutationKey()
        return mutationOptions<AcceptAodRunRunActionsMutationResponse, ResponseErrorConfig<AcceptAodRunRunActions400 | AcceptAodRunRunActions404>, {id: AcceptAodRunRunActionsPathParams["id"], data: AcceptAodRunRunActionsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return acceptAodRunRunActions(id, data, config)
          },
        })

}

/**
 * @description Re-executes the AOD run job with minimum efficiency requirement removed for runs with COMPLETED_WITHOUT_EXPORT status
 * @summary Accept a run
 * {@link /aod-runs/:id/accept}
 */
export function useAcceptAodRunRunActions<TContext>(options: 
{
  mutation?: UseMutationOptions<AcceptAodRunRunActionsMutationResponse, ResponseErrorConfig<AcceptAodRunRunActions400 | AcceptAodRunRunActions404>, {id: AcceptAodRunRunActionsPathParams["id"], data: AcceptAodRunRunActionsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AcceptAodRunRunActionsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? acceptAodRunRunActionsMutationKey()

          const baseOptions = acceptAodRunRunActionsMutationOptions(config) as UseMutationOptions<AcceptAodRunRunActionsMutationResponse, ResponseErrorConfig<AcceptAodRunRunActions400 | AcceptAodRunRunActions404>, {id: AcceptAodRunRunActionsPathParams["id"], data: AcceptAodRunRunActionsMutationRequest}, TContext>
          

          return useMutation<AcceptAodRunRunActionsMutationResponse, ResponseErrorConfig<AcceptAodRunRunActions400 | AcceptAodRunRunActions404>, {id: AcceptAodRunRunActionsPathParams["id"], data: AcceptAodRunRunActionsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AcceptAodRunRunActionsMutationResponse, ResponseErrorConfig<AcceptAodRunRunActions400 | AcceptAodRunRunActions404>, {id: AcceptAodRunRunActionsPathParams["id"], data: AcceptAodRunRunActionsMutationRequest}, TContext>
      
}